import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class MotabilityReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment().toDate(),
            endDate: moment().toDate(),
            isLoading: false,
            getInvoicedReportUrl: '/api/v1/portal/portal-admin/motability-report',
            InvoicedJobsReportData: [],
            downloadReportName: 'Motability Report',
            selectedCustomers: [],
            customers: [],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];
        return fetch(this.state.url, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
            },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                response.map((customer) => {
                    options.push({
                        label: customer.company.short_name + '-' + customer.name,
                        value: customer.id
                    });
                });
                this.setState({
                    customers: options,
                    isLoading: false
                });
            });
        });
    }
    handleStartDateChange(date) {
        this.setState({ startDate: date })
    }
    handleEndDateChange(date) {
        this.setState({ endDate: date })
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({ selectedCustomers });
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({ isLoading: true });
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
                , 'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                customer_ids: this.state.selectedCustomers,
                start_date: moment(this.state.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.state.endDate).format("YYYY-MM-DD")
            }),
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                this.setState({
                    InvoicedJobsReportData: response.jobs,
                    isLoading: false
                })
            });
        });
    }
    download(filename, text) {
        this.setState({ isDownloading: true });
        filename = filename + ' From ' + moment(this.state.startDate).format("YYYY-MM-DD") + ' To ' + moment(this.state.endDate).format("YYYY-MM-DD") + '.csv';
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    render() {
        let invoicedJobs = [];
        const { selectedCustomers } = this.state;
        let downloadableCsvDataInvoiced = "MOVEMENT REF,INFORMED DATE,VEHICLE DELIVERED DATE,REG,COLLECTION LOCATION POSTCODE,DELIVERY LOCATION POSTCODE,OVER WATER MOVE FLAG,NON DRIVEABLE FLAG,MOVEMENT DISTANCE MILES,WORKING DAYS CALC,NON RUNNER SUPPLEMENT,MOVE COST\n";
        if (this.state.InvoicedJobsReportData.length > 0) {
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/" + currentJob.id;
                const {
                    id,
                    created_at,
                    vehicle: { registration_number },
                    pickup_address: {  postcode: pickup_postcode = '' } = {},
                    dropoff_address: { postcode: dropoff_postcode = '' } = {},
                    distance_in_miles,
                    driver_completed_at,
                    customer_invoiced_price,
                    days_diff,
                } = currentJob;


                invoicedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16">
                            <a href={joburl}>{id}</a>
                        </td>
                        <td>{created_at ? moment(created_at).format("DD/MM/YY") : ""}</td>
                        <td>{driver_completed_at ? moment(driver_completed_at).format("DD/MM/YY") : ""}</td>
                        <td>{registration_number}</td>
                        <td>{pickup_postcode}</td>
                        <td>{dropoff_postcode}</td>
                        <td>n</td>
                        <td>n</td>
                        <td>{distance_in_miles}</td>
                        <td>{days_diff}</td>
                        <td>n</td>
                        <td>£{customer_invoiced_price}</td>
                    </tr>
                );

                downloadableCsvDataInvoiced += `${id},${created_at ? moment(created_at).format("DD/MM/YY") : ""},${driver_completed_at ? moment(driver_completed_at).format("DD/MM/YY") : ""},${registration_number},${pickup_postcode},${dropoff_postcode},n,n,${distance_in_miles},${days_diff},n,${customer_invoiced_price}\n`;
            });
        } else {
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="23" className='text-center'>No Records</td></tr>
            );
        }

        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Motability Report</h2>
                    <br />
                </div>

                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate} />
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate} />
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br />
                        <div>
                            <StatefulMultiSelect
                                options={this.state.customers}
                                selected={selectedCustomers}
                                onSelectedChanged={this.handleCustomerSelection}
                                overrideStrings={{
                                    selectSomeItems: "Select Customers...",
                                    allItemsAreSelected: "All Customers are Selected",
                                    selectAll: "Select All",
                                    search: "Search Customer",
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                <i className="fa fa-save"></i> Generate Customer Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                }}
                            >
                                <i className="fa fa-download"></i> Download Customer Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} jobs found..</b></label></div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl font-normal">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Movemet Ref</th>
                                        <th>Informed Date</th>
                                        <th>Vehicle Delivered Date</th>
                                        <th>Reg/VIN</th>
                                        <th>Collection Location Postcode</th>
                                        <th>Delivery Location Postcode</th>
                                        <th>Over Water Move Flag</th>
                                        <th>Non Driveable Flag</th>
                                        <th>Movement Distance Miles</th>
                                        <th>Working Days Calculated</th>
                                        <th>Non Runner Supplement</th>
                                        <th>Job price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ?
                                        (<tr><td colSpan="23"><span className="add-loading-text">
                                            <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                        invoicedJobs
                                    }
                                </tbody>
                            </table>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('react-component-g4-logistics-portal-admin-motability_report')) {
    ReactDOM.render(<MotabilityReport />,
        document.getElementById('react-component-g4-logistics-portal-admin-motability_report'));
}
